import { FormattedMessage as FM } from "react-intl";

import { PrintIcon, EnvelopeIcon } from "components/Icons";

function ItemMenu({ value, handleClick, type }) {
  return (
    <div
      key={value.label}
      className="flex px-3 py-2 h-10 text-sm text-neutral-600 rounded-lg hover:bg-stone-100 hover:text-teal-600 hover:cursor-pointer active:scale-95"
      onClick={() => handleClick(value)}
    >
      <div className="grid">
        <p className="mb-2 my-auto">
          <FM id={value.name} />
        </p>
        {/* {item.description && (
          <p className="mb-2">
            <FM id={action.description} />
          </p>
        )}*/}
      </div>
      {type === "report" && (
        <div className="flex ml-auto w-18">
          <PrintIcon className="h-5 fill-current ml-auto my-auto" />
        </div>
      )}
    </div>
  );
}

export default ItemMenu;
